module.exports = __webpack_public_path__ + "5a27de2fc5112c7e139827f115df5098.png";